// src/components/common/AppleSpinner.js
import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';

// Animación para las aspas del spinner según el estilo de Apple
const iSpinnerBlade = keyframes`
  0% {
    opacity: 0.85;
  }
  50% {
    opacity: 0.25;
  }
  100% {
    opacity: 0.25;
  }
`;

const SpinnerContainer = styled(Box)(({ theme, customSize }) => ({
  position: 'relative',
  width: customSize,
  height: customSize,
}));

const Blade = styled(Box)(({ theme, index, total, customSize }) => {
  // Calcular dimensiones proporcionales basadas en el tamaño personalizado
  // Aumentando el factor de multiplicación para hacer las barras más gruesas
  const bladeWidth = Math.max(3, customSize * 0.10); // Aumentado de 0.07 a 0.12
  const bladeHeight = Math.max(6, customSize * 0.25);
  const borderRadius = bladeWidth / 2;
  
  // Calcular ángulo y retraso para cada barra
  const angle = (360 / total) * index;
  const delay = -2 + ((1 / total) * index);
  
  return {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: bladeWidth,
    height: bladeHeight,
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.8)' : '#8e8e93',
    borderRadius: borderRadius,
    animation: `${iSpinnerBlade} 1s linear infinite`,
    animationDelay: `${delay}s`,
    willChange: 'opacity',
    transformOrigin: '50% 100%', // El origen de la transformación está en la base de cada barra
    transform: `translate(-50%, 0%) rotate(${angle}deg) translateY(-${bladeHeight/2}px)`,
  };
});

const AppleSpinner = ({ sizeDesktop = 60, sizeMobile = 35, barsCount = 8 }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const customSize = isMobile ? sizeMobile : sizeDesktop;

  return (
    <SpinnerContainer customSize={customSize}>
      {[...Array(barsCount)].map((_, index) => (
        <Blade 
          key={index} 
          index={index} 
          total={barsCount} 
          customSize={customSize} 
        />
      ))}
    </SpinnerContainer>
  );
};

export default AppleSpinner;